// Patient Journey Monitor API helpers
import { api } from "./client";

export interface KPIThreshold {
  key: string;
  label: string;
  lookerField: string;
  condition: ">" | "<" | ">=" | "<=" | "=";
  value: number;
  severity: "warning" | "critical";
  stage?: "2" | "3" | "5";
  monitorNumber?: string;
  methodologyRef?: string;
  description?: string;
}

export interface PjEscalation {
  id: string;
  hierarchyId: string;
  level: number;
  status: "pending" | "bumped" | "resolved";
  assignedTo: string;
  assignedRole: string;
  summary: string;
  bumpAt: string | null;
  bumpAfterMinutes: number;
  resolvedBy: string | null;
  resolutionNote: string | null;
  resolvedAt: string | null;
  createdAt: string;
  // Joined from pj_automation_alerts
  alert?: {
    metricKey: string;
    metricValueAtAlert: number;
    thresholdValue: number;
    severity: string;
  };
}

export interface IssueMemoryRecord {
  id: string;
  hierarchyId: string;
  issueType: string;
  metricKey: string;
  rootCause: string | null;
  resolutionSummary: string | null;
  effectivenessScore: number | null;
  resolvedBy: string | null;
  occurrenceCount: number;
  lastOccurredAt: string;
  lastResolvedAt: string | null;
}

function companyPath(companyId: string) {
  return `/companies/${companyId}`;
}

export const patientJourneyApi = {
  // Escalations
  getEscalations: (
    companyId: string,
    filters?: { hierarchyId?: string; status?: string },
  ) => {
    const params = new URLSearchParams();
    if (filters?.hierarchyId) params.set("hierarchyId", filters.hierarchyId);
    if (filters?.status) params.set("status", filters.status);
    const qs = params.toString();
    return api.get<PjEscalation[]>(
      `${companyPath(companyId)}/escalations${qs ? `?${qs}` : ""}`,
    );
  },

  resolveEscalation: (
    companyId: string,
    id: string,
    data: { resolvedBy: string; resolutionNote: string },
  ) =>
    api.patch<PjEscalation>(
      `${companyPath(companyId)}/escalations/${id}/resolve`,
      data,
    ),

  // Issue Memory
  getIssueMemory: (companyId: string, agentId?: string) => {
    const params = agentId ? `?agentId=${agentId}` : "";
    return api.get<IssueMemoryRecord[]>(
      `${companyPath(companyId)}/issue-memory${params}`,
    );
  },
};
